import React, { useState, useRef, useEffect } from "react";
import Header from "../../layouts/Header";
import { useHistory } from "react-router";
import "../../assets/styles/local/Quote.css";
import quoteIcon from "../../assets/icons/quote2.svg";
import shoppingCartLight from "../../assets/icons/shopping-cartLight.svg";
import InvoiceLight from "../../assets/icons/InvoiceLight.svg";
import Link from "../../assets/icons/Link.svg";
import send from "../../assets/icons/send.svg";
import close from "../../assets/icons/x-circle.svg";
import clipboard from "../../assets/icons/clipboard.svg";
import plusIcon from "../../assets/icons/Pluswhite.svg";
import Kebab from "../../assets/icons/Kebab Calculations.svg";
import pdf from "../../assets/icons/Pdf icon.svg";
import invoice from "../../assets/icons/Invoice.svg";
import delete1 from "../../assets/icons/Group 2723.svg";
import duplicate from "../../assets/icons/Duplicate.svg";
import downarrow from "../../assets/icons/downarrow.svg";
import shoppingCart from "../../assets/icons/shopping-cart.svg";
import edit from "../../assets/icons/edit-3.svg";
import searchicon from "../../assets/icons/search.svg";
import Xicon from "../../assets/icons/Xicon.svg";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import smaliIcon from "..//../assets/icons/meh.svg";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import {
  ProjectDropdown,
  FetchQuotesByCompanyId,
  FetchlastQuotecode,
  AddQuotes,
  ApproveQuotes,
  DeactivatedQuote,
  CreateDuplicateQuotes,
  activateQuote,
  sendApprovedQuotesEmail,
  availableTemplates,
  QuotesGeneratePDF,
} from "../../redux/actions/action";
import { ROLES } from "../../utils/helpers/userRole";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import QuoteLinkContextMenu from "../../components/Quote/QuoteLinkContextMenu";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import QuotesApprovedPopup from "../../components/Quote/QuotesApprovedPopup";
import QuotesApprovedMailPopup from "../../components/Dailogs/QuotesApprovedMailPopup";
import Loader from "../../components/Dailogs/Loader";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import grapesTemplateApi from "../../services/grapesTemplateApi";

const Quote = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const roleAccess = window.localStorage.getItem("roleid");
  const companyId = window.localStorage.getItem("companyid");
  const packageId = window.localStorage.getItem("packageId");
  const token = window.localStorage.getItem("token");

  const ProjectDropdownResponse = useSelector(
    (state) => state.user.fetchProjectDropdown,
  );
  const FetchlastQuotecodeResponse = useSelector(
    (state) => state.user.FetchlastQuotecodeResponse,
  );
  const AddQuotesResponse = useSelector(
    (state) => state.user.AddQuotesResponse,
  );
  const ApproveQuotesResponse = useSelector(
    (state) => state.user.ApproveQuotesResponse,
  );
  const DeativatedQuoteResponse = useSelector(
    (state) => state.user.DeativatedQuoteResponse,
  );
  const activateQuoteResponse = useSelector(
    (state) => state.user.activateQuoteResponse,
  );
  const CreateDuplicateQuotesResponse = useSelector(
    (state) => state.user.CreateDuplicateQuotesResponse,
  );
  const FetchQuotesByCompanyidResponse = useSelector(
    (state) => state.user.FetchQuotesByCompanyidResponse,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Quotes").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [btnHover, setBtnHover] = useState(false);
  const [project, setProject] = useState({ projectid: "", projectname: "" });
  const [query, setQuery] = useState("");
  const [activePageOption, setActivePageOption] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [inputWidth, setInputWidth] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [quoteList, setQuoteList] = useState([]);
  const [fullQuoteList, setFullQuoteList] = useState([]);
  const [newQuoteCode, setNewQuoteCode] = useState("");
  const [projectDropList, setProjectDropList] = useState([]);
  const [fullProjectDropList, setFullProjectDropList] = useState([]);
  const [margin, setMargin] = useState("");
  const [uLaborPrice, setULaborPrice] = useState("");

  const [menuActiveList, setMenuActiveList] = useState([]);

  const PaginationChange = (event) => {
    setPageNumber(event.selected);
  };

  //  if (ROLES.VIEWER === roleAccess) {

  //  }
  useEffect(() => {
    dispatch(ProjectDropdown());
  }, []);

  useEffect(() => {
    dispatch(FetchlastQuotecode());
  }, [showModal]);

  useEffect(() => {
    if (query) {
      dispatch(FetchQuotesByCompanyId(itemsPerPage, pageNumber + 1, query));
    } else {
      dispatch(FetchQuotesByCompanyId(itemsPerPage, pageNumber + 1));
    }
  }, [itemsPerPage, pageNumber]);

  //setting default value of item per pages 50 & 20 to page 1
  useEffect(() => {
    if (itemsPerPage === 50 || itemsPerPage === 20) {
      setPageNumber(0);
    }
  }, [itemsPerPage]);

  useEffect(() => {
    if (ProjectDropdownResponse?.status === true) {
      setProjectDropList(ProjectDropdownResponse?.data);
      setFullProjectDropList(ProjectDropdownResponse?.data);
    }
  }, [ProjectDropdownResponse]);

  useEffect(() => {
    if (FetchQuotesByCompanyidResponse?.status === true) {
      setQuoteList(FetchQuotesByCompanyidResponse?.data);
      setFullQuoteList(FetchQuotesByCompanyidResponse?.data);
      let pages = Math.ceil(
        FetchQuotesByCompanyidResponse?.totalCount / itemsPerPage,
      );
      setTotalPages(pages);
    }
  }, [FetchQuotesByCompanyidResponse]);

  useEffect(() => {
    // if (query) {
    //   let list = [...fullQuoteList];
    //   list = list?.filter((quote) => {
    //     return (
    //       quote?.quotecode?.toLowerCase().startsWith(query.toLowerCase()) ||
    //       quote?.projectcode?.toLowerCase().startsWith(query.toLowerCase()) ||
    //       quote?.projectname?.toLowerCase().startsWith(query.toLowerCase()) ||
    //       quote?.clientname?.clientname?.toLowerCase().startsWith(query.toLowerCase()) ||
    //       quote?.status?.toLowerCase().startsWith(query.toLowerCase())
    //     );
    //   });
    //   setQuoteList(list);
    // } else {
    //   setQuoteList([...fullQuoteList]);
    // }

    if (query) {
      dispatch(FetchQuotesByCompanyId(itemsPerPage, pageNumber + 1, query));
    } else {
      dispatch(FetchQuotesByCompanyId(itemsPerPage, pageNumber + 1));
    }
  }, [query]);

  useEffect(() => {
    if (AddQuotesResponse?.status === true) {
      setShowModal(false);
      dispatch(FetchQuotesByCompanyId(itemsPerPage, pageNumber + 1));
      setProject({ projectid: "", projectname: "" });
      setULaborPrice("");
      setMargin("");
      history.push(
        `/quote/${AddQuotesResponse?.data?.quoteid}`,
        // "/quote-calculation",
        `${AddQuotesResponse?.data?.quotecode}@@${AddQuotesResponse?.data?.quoteid}@@Add@@/quote`,
      );
    }
  }, [AddQuotesResponse]);

  useEffect(() => {
    if (ApproveQuotesResponse?.status === true) {
      dispatch(FetchQuotesByCompanyId(itemsPerPage, pageNumber + 1));
    }
  }, [ApproveQuotesResponse]);

  useEffect(() => {
    if (DeativatedQuoteResponse?.status === true) {
      dispatch(FetchQuotesByCompanyId(itemsPerPage, pageNumber + 1));
      // if (ROLES.OWNER === roleAccess || ROLES.MANAGER === roleAccess) {
      //   return handleGeneralNotification({
      //     notificationType: "CUSTOM",
      //     text: `${DeativatedQuoteResponse?.message} ${DeativatedQuoteResponse?.data?.quotecode}`,
      //   });
      // }
    }
  }, [DeativatedQuoteResponse]);

  useEffect(() => {
    if (activateQuoteResponse?.status === true) {
      dispatch(FetchQuotesByCompanyId(itemsPerPage, pageNumber + 1));
    }
  }, [activateQuoteResponse]);

  useEffect(() => {
    if (CreateDuplicateQuotesResponse?.status === true) {
      dispatch(FetchQuotesByCompanyId(itemsPerPage, pageNumber + 1));
      dispatch(FetchlastQuotecode());
    }
  }, [CreateDuplicateQuotesResponse]);

  useEffect(() => {
    if (FetchlastQuotecodeResponse?.status === true) {
      setNewQuoteCode(FetchlastQuotecodeResponse?.data?.quotecode);
      setInputWidth(+FetchlastQuotecodeResponse?.data?.quotecode?.length * 10);
    }
  }, [FetchlastQuotecodeResponse]);

  return (
    <>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div className="flex-wrap gap-5 d-flex align-items-baseline">
            <div
              className="projectText2"
              onClick={() => {
                history.push("/quote");
              }}
              style={{
                marginTop: "0px",
                fontSize: "16px",
              }}
            >
              {/* Quotes */}
              {t("Quotes")}
            </div>
          </div>
        }
      />

      <div style={{ padding: "0 36.35px 0 24px" }}>
        {roleAccess !== ROLES.VIEWER && (
          <div style={{ display: "flex", justifyContent: "end" }}>
            <button
              className="addQuoteBtn addQouteBtnhide"
              onMouseEnter={() => setBtnHover(true)}
              onMouseLeave={() => setBtnHover(false)}
              onClick={() => setShowModal(true)}
            >
              {btnHover && (
                <img
                  src={plusIcon}
                  style={{
                    width: "clamp(16px, 1.171vw, 1.171vw)",
                    height: "clamp(16px, 1.171vw, 1.171vw)",
                  }}
                />
              )}
              {!btnHover && (
                <img
                  src={quoteIcon}
                  style={{
                    width: "clamp(16px, 1.171vw, 1.171vw)",
                    height: "clamp(16px, 1.171vw, 1.171vw)",
                  }}
                />
              )}
              {/* Add Quote */}
              {t("Add Quote")}
            </button>
          </div>
        )}
        <div className="flex-wrap gap-5 d-flex align-items-baseline">
          <div
            className="projectText2 project-text02"
            onClick={() => {
              history.push("/quote");
            }}
            style={{
              marginTop: "0px",
              fontSize: "16px",
            }}
          >
            {/* Quotes */}
            {t("Quotes")}
          </div>
        </div>
        <div className="quoteListDiv position-relative">
          <section
            className={`quoteListSection ${
              companyId == "28830f30-b321-4662-a576-f23451677741"
                ? "hide-link"
                : ""
            }`}
          >
            <p className="quoteListHead quote-list-head-mobile">
              {" "}
              {packageId === process.env.REACT_APP_IS_PREMIUM ? "Link" : ""}
            </p>
            <p className="quoteListHead mb-2">
              {/* Quote ID */}
              {t("Quote ID")}
            </p>
            <p className="quoteListHead">
              {/* Client */}
              {t("Client")}
            </p>
            <p className="quoteListHead quote-list-head-mobile">
              {/* Project */}
              {t("Project")}
            </p>
            <p className="quoteListHead quote-list-head-mobile invisible">
              {/* Project Name */}
              {t("Project Name")}
            </p>
            <p className="quoteListHead quote-list-head-mobile">
              {/* Total */}
              {t("Total")}
            </p>
            <p className="quoteListHead">
              {/* Status */}
              {t("Status")}
            </p>
            {/* <p className="quoteListHead quote-list-head-mobile">Performed</p> */}
          </section>
          {quoteList?.length > 0 && (
            <div className="quote-list-overflow mt-1">
              {quoteList?.map((quote, index) => {
                return (
                  <SingleQuoteItem
                    index={index}
                    quoteCode={quote?.quotecode}
                    link={quote?.link}
                    projectCode={quote?.projectcode}
                    projectname={quote?.projectname}
                    status={quote?.status}
                    client={quote?.clientname}
                    total={quote?.total}
                    quoteid={quote?.quoteid}
                    userid={quote?.userid}
                    newQuoteCode={newQuoteCode}
                    quoteList={quoteList}
                    setMenuActiveList={setMenuActiveList}
                    menuActiveList={menuActiveList}
                    quote={quote}
                    FetchTranslationList={FetchTranslationList}
                  />
                );
              })}
            </div>
          )}
          {quoteList?.length === 0 && (
            <div className="text-cente-r pt-2">No data to display!</div>
          )}
          {query && quoteList?.length === 0 && (
            <div
              className="row container mt-5 pt-5"
              style={{ marginBottom: "3rem" }}
            >
              <img
                src={smaliIcon}
                alt="smali"
                width={35}
                height={35}
                className="mt-5 "
              />
              <h6
                className="mt-1"
                style={{
                  fontSize: "14px",
                  fontWeight: 400,
                  textAlign: "center",
                  color: "#707070",
                }}
              >
                Sorry.
                <br /> No results for your criteria.
                <br /> Try to refine your search or enter a new search.
              </h6>
            </div>
          )}
        </div>

        <div className="quotePageDiv">
          <section className="quotePageSec1" style={{ position: "relative" }}>
            <p>
              {/* Items per page */}
              {t("Items per page")}
            </p>
            <article
              className="quotePageArt"
              onClick={() => setActivePageOption(!activePageOption)}
              style={{ paddingLeft: "0", alignItems: "center" }}
            >
              <p>{itemsPerPage}</p>
              <img
                src={downarrow}
                style={{
                  width: "10px",
                  height: "6px",
                  transform: activePageOption
                    ? "rotate(-180deg)"
                    : "rotate(0deg)",
                  transitionDuration: "300ms",
                }}
              />
            </article>
            <article
              className="quotePageArt quotePageArt2"
              onClick={() => setActivePageOption(!activePageOption)}
              style={{
                position: "absolute",
                right: "0",
                bottom: "0",
                height: activePageOption
                  ? "clamp(82px, 6.003vw, 6.003vw)"
                  : "0",
                transitionDuration: "300ms",
                visibility: activePageOption ? "visible" : "none",
                paddingTop: activePageOption ? "11px" : "0",
              }}
            >
              <article
                style={{
                  display: activePageOption ? "flex" : "none",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "start",
                }}
              >
                <p
                  style={{
                    fontWeight: itemsPerPage === 10 ? "800" : "700",
                    color: itemsPerPage === 10 ? "#95A7C6" : "#333333",
                  }}
                  onClick={() => setItemsPerPage(10)}
                >
                  10
                </p>
                <p
                  style={{
                    fontWeight: itemsPerPage === 20 ? "800" : "700",
                    color: itemsPerPage === 20 ? "#95A7C6" : "#333333",
                  }}
                  onClick={() => setItemsPerPage(20)}
                >
                  20
                </p>
              </article>
              <article
                className="quotePageArt"
                onClick={() => setActivePageOption(!activePageOption)}
                style={{
                  paddingLeft: "0",
                  alignItems: "center",
                  display: activePageOption ? "flex" : "none",
                }}
              >
                <p
                  style={{
                    fontWeight: itemsPerPage === 50 ? "800" : "700",
                    color: itemsPerPage === 50 ? "#95A7C6" : "#333333",
                  }}
                  onClick={() => setItemsPerPage(50)}
                >
                  50
                </p>
                <img
                  src={downarrow}
                  style={{
                    width: "10px",
                    height: "6px",
                    transform: activePageOption
                      ? "rotate(-180deg)"
                      : "rotate(0deg)",
                    transitionDuration: "300ms",
                  }}
                />
              </article>
            </article>
          </section>
          <section className="quotePageSec2">
            <div className="table-filter-info-member">
              <ReactPaginate
                nextLabel=""
                forcePage={pageNumber}
                disableInitialCallback={true}
                onPageChange={PaginationChange}
                pageRangeDisplayed={3}
                marginPagesDisplayed={1}
                pageCount={totalPages}
                previousLabel=""
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="d-none"
                nextClassName="d-none"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="quote-pagination"
                activeClassName="active"
                renderOnZeroPageCount={null}
              />
            </div>
          </section>
        </div>
      </div>
      <div className="addQoutebtnMobile">
        <button
          className="addQuoteBtn "
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          onClick={() => setShowModal(true)}
        >
          {btnHover && (
            <img
              src={plusIcon}
              style={{
                width: "clamp(16px, 1.171vw, 1.171vw)",
                height: "clamp(16px, 1.171vw, 1.171vw)",
              }}
            />
          )}
          {!btnHover && (
            <img
              src={quoteIcon}
              style={{
                width: "clamp(16px, 1.171vw, 1.171vw)",
                height: "clamp(16px, 1.171vw, 1.171vw)",
              }}
            />
          )}
          Add Quote
        </button>
      </div>
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        newQuoteCode={newQuoteCode}
        setNewQuoteCode={setNewQuoteCode}
        project={project}
        setProject={setProject}
        projectDropList={projectDropList}
        setProjectDropList={setProjectDropList}
        fullProjectDropList={fullProjectDropList}
        inputWidth={inputWidth}
        setInputWidth={setInputWidth}
        margin={margin}
        setMargin={setMargin}
        uLaborPrice={uLaborPrice}
        setULaborPrice={setULaborPrice}
        FetchTranslationList={FetchTranslationList}
      />
    </>
  );
};

const Modal = ({
  showModal,
  setShowModal,
  newQuoteCode,
  setNewQuoteCode,
  project,
  setProject,
  projectDropList,
  setProjectDropList,
  fullProjectDropList,
  inputWidth,
  setInputWidth,
  margin,
  setMargin,
  uLaborPrice,
  setULaborPrice,
  FetchTranslationList,
}) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [showSearchModal, setShowSearchModal] = useState(false);
  const modalRef = useRef(null);
  const inputRef = useRef(null);
  const marginInputRef = useRef(null);
  const [marginInputWidth, setMarginInputWidth] = useState("");
  const packageId = window.localStorage.getItem("packageId");
  const companyId = window.localStorage.getItem("companyid");
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowSearchModal(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  useEffect(() => {
    if (search) {
      let list = [...fullProjectDropList];
      list = list?.filter((project) => {
        return (
          project?.projectname?.toLowerCase().includes(search.toLowerCase()) ||
          project?.projectcode?.toLowerCase().includes(search.toLowerCase())
        );
      });
      setProjectDropList(list);
    } else {
      setProjectDropList([...fullProjectDropList]);
    }
  }, [search]);

  useEffect(() => {
    // Focus input when modal opens
    if (showSearchModal && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showSearchModal]);

  return (
    <>
      <div
        className="quote-modal-cont"
        style={{ transform: showModal ? "scale(1)" : "scale(0)" }}
      >
        <div className="modal-div">
          <div
            className="modal-div-absolute quote-modal-width"
            style={{
              width:
                packageId === process.env.REACT_APP_IS_PREMIUM
                  ? companyId == "28830f30-b321-4662-a576-f23451677741"
                    ? "auto"
                    : "auto"
                  : "auto",
            }}
          >
            <section className="quote-modal-sec1">
              {/* New Quote */}
              {t("New Quote")}
            </section>
            <div
              className="quote-modal-grid"
              style={{
                display:
                  packageId === process.env.REACT_APP_IS_PREMIUM
                    ? companyId == "28830f30-b321-4662-a576-f23451677741"
                      ? "block"
                      : "grid"
                    : "block",
              }}
            >
              <div>
                <section className="quote-modal-sec2">
                  <p>
                    {/* Quote ID */}
                    {t("Quote ID")}
                  </p>
                  <article className="fr quote-number-icon">
                    {/* <p className="quote-number-bold">{newQuoteCode}</p> */}
                    <input
                      ref={inputRef}
                      className="quote-number-bold input-quote-number"
                      value={newQuoteCode}
                      onChange={(e) => {
                        setNewQuoteCode(e.target.value);
                        setInputWidth(+e.target.value.length * 10);
                      }}
                      style={{ width: `${inputWidth}px`, minWidth: "50px" }}
                    />
                    <img
                      src={edit}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        inputRef.current.focus();
                      }}
                    />
                  </article>
                </section>
                <section className="quote-modal-sec3">
                  <p>
                    {/* Project */}
                    {t("Project")}
                  </p>
                  <div
                    className="fr quote-number-icon-2"
                    style={{ maxWidth: "80%" }}
                  >
                    <div className="quote-modal-select">
                      <p
                        className="choose-project ellipse"
                        onClick={() => setShowSearchModal(true)}
                      >
                        {project?.projectid
                          ? // ? project?.projectname
                            `${project?.projectcode} ┃ ${project?.projectname}`
                          : t("Choose a project")}
                      </p>
                      <div
                        ref={modalRef}
                        className="choose-project-modal"
                        style={{
                          transform: showSearchModal ? "scale(1)" : "scale(0)",
                          transitionDuration: "300ms",
                        }}
                      >
                        <p className="choose-project p-3 pb-0">
                          {/* Choose a project */}
                          {t("Choose a project")}
                        </p>
                        <section
                          className="quote-modal-search mx-2"
                          style={{ width: "90%" }}
                        >
                          <img
                            src={searchicon}
                            alt="Search Icon"
                            style={{
                              flexShrink: "0",
                              width: "17px",
                              height: "17px",
                            }}
                          />
                          <input
                            ref={inputRef}
                            className="quote-modal-input"
                            placeholder="Search..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                        </section>
                        <section className="quote-modal-list">
                          {projectDropList?.map((project, index) => {
                            return (
                              <p
                                className="choose-project ulterDrop"
                                key={index}
                                style={{ textTransform: "capitalize" }}
                                onClick={() => {
                                  setProject({
                                    projectid: project?.projectid,
                                    projectname: project?.projectname,
                                    projectcode: project?.projectcode,
                                  });
                                  setShowSearchModal(false);
                                }}
                              >
                                {project?.projectcode}&nbsp;┃&nbsp;
                                {/* {project?.projectname} */}
                                {project.projectname.length > 20
                                  ? project.projectname.slice(0, 20) + "..."
                                  : project.projectname}
                              </p>
                            );
                          })}
                        </section>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="quote-modal-right quote-list-head-mobile hidefor-tablet"
                style={{
                  display:
                    packageId === process.env.REACT_APP_IS_PREMIUM
                      ? companyId == "28830f30-b321-4662-a576-f23451677741"
                        ? "none"
                        : "block"
                      : "none",
                }}
              >
                <div className="quote-right-flex" style={{ gap: "52px" }}>
                  <p>
                    {/* Margin */}
                    {t("Margin")}
                  </p>
                  <article
                    className="fr quote-number-icon"
                    style={{ gap: "0" }}
                  >
                    <input
                      ref={marginInputRef}
                      className="quote-number-bold input-quote-number"
                      value={margin}
                      placeholder="0,00"
                      type="number"
                      onChange={(e) => {
                        setMargin(e.target.value);
                        setMarginInputWidth(+e.target.value.length * 10);
                      }}
                      style={{
                        width: `${marginInputWidth}px`,
                        minWidth: "55px",
                        maxWidth: "80px",
                      }}
                    />
                    <p className="quote-number-bold input-quote-number">%</p>
                  </article>
                </div>
                <div
                  className="quote-right-flex"
                  style={{ marginTop: "13px", alignItems: "end" }}
                >
                  <p style={{ flexShrink: "0" }}>
                    {/* Unit <br /> Labor Cost */}
                    {t("Unit")}
                    <br />
                    {t("Labor Cost")}
                  </p>
                  <article
                    className="fr quote-number-icon"
                    style={{ gap: "0" }}
                  >
                    <input
                      className="quote-number-bold input-quote-number"
                      value={uLaborPrice}
                      type="number"
                      placeholder="€ 0,00"
                      onChange={(e) => {
                        setULaborPrice(e.target.value);
                      }}
                      style={{ minWidth: "30px", maxWidth: "50%" }}
                    />
                  </article>
                </div>
              </div>
            </div>
            <section className="quote-modal-btns">
              <p style={{ minWidth: "60px" }}></p>
              <button
                type="button"
                className="addProCancel quote-cancel-btn"
                onClick={() => {
                  setShowModal(false);
                  setMargin("");
                  setULaborPrice("");
                }}
              >
                {/* Cancel */}
                {t("Cancel")}
              </button>
              <button
                type="button"
                className="quote-add-btn"
                onClick={() => {
                  if (!project?.projectid) return;
                  dispatch(
                    AddQuotes(
                      project?.projectid,
                      newQuoteCode,
                      "",
                      0,
                      "Waiting",
                      margin,
                      uLaborPrice,
                    ),
                  );
                }}
              >
                {/* Add */}
                {t("Add")}
              </button>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

const SingleQuoteItem = ({
  index,
  quoteCode,
  link,
  projectCode,
  projectname,
  status,
  client,
  total,
  quoteid,
  userid,
  newQuoteCode,
  quoteList,
  setMenuActiveList,
  menuActiveList,
  quote,
  FetchTranslationList,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [menuActive, setMenuActive] = useState(false);
  const roleAccess = window.localStorage.getItem("roleid");
  const companyId = window.localStorage.getItem("companyid");
  const packageId = window.localStorage.getItem("packageId");
  const token = window.localStorage.getItem("token");

  const [isTop, setIsTop] = useState(false);
  const [top, setTop] = useState(0);
  const [isDownloadingQuote, setIsDownloadingQuote] = useState(false);
  const t = (key) => FetchTranslationList?.[key] || "";

  const deactivateFunction = () => {
    const user = window.localStorage.getItem("userid");
    if (ROLES.USER === roleAccess && status === "Deactivated") {
      if (user === userid) {
        setMenuActive(false);
        return dispatch(activateQuote(quoteid));
      } else {
        handleGeneralNotification({
          notificationType: "CUSTOM",
          text: `You cannot activate the quote created by other user.`,
        });
      }
    }
    if (ROLES.USER === roleAccess && status === "Waiting") {
      if (user === userid) {
        setMenuActive(false);
        return dispatch(DeactivatedQuote(quoteid, 0));
      } else {
        handleGeneralNotification({
          notificationType: "CUSTOM",
          text: `You cannot deactivate the quote created by other user.`,
        });
      }
    }
    if (roleAccess === ROLES.OWNER || roleAccess === ROLES.MANAGER) {
      setMenuActive(false);
      if (status === "Deactivated") return dispatch(activateQuote(quoteid));
      if (status === "Waiting") return dispatch(DeactivatedQuote(quoteid, 0));
      if (status === "Approved") return dispatch(DeactivatedQuote(quoteid, 0));
    }
  };

  const downloadDefaultGrapesQuotePdf = async () => {
    setIsDownloadingQuote(true);

    try {
      const response = await grapesTemplateApi.renderDefaultQuotePdf(quoteid);
      if (!response.headers["content-type"]?.includes("application/pdf")) {
        const payload = JSON.parse(await response.data.text());
        throw new Error(
          payload?.message ||
            "Unable to generate the default quote template PDF.",
        );
      }

      const objectUrl = URL.createObjectURL(response.data);
      const downloadLink = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"] || "";
      const fileNameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i,
      );

      downloadLink.href = objectUrl;
      downloadLink.download =
        fileNameMatch?.[1]?.replace(/["']/g, "") || `${quoteCode}.pdf`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      let message =
        error?.message || "Unable to download the default quote template PDF.";
      if (error?.response?.data instanceof Blob) {
        try {
          const payload = JSON.parse(await error.response.data.text());
          message = payload?.message || message;
        } catch {
          // The response is not JSON, so keep the safe fallback message.
        }
      }

      handleGeneralNotification(
        { notificationType: "CUSTOM", text: message },
        false,
      );
    } finally {
      setIsDownloadingQuote(false);
    }
  };

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  const kebabRef = useRef();
  const openLinkBoxRef = useRef();

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (kebabRef.current && !kebabRef.current.contains(event.target)) {
      setMenuActiveList([]);
    }

    if (
      openLinkBoxRef.current &&
      !openLinkBoxRef.current.contains(event.target)
    ) {
      setOpenLink(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const [approvedConfirmationPopup, setApprovedConfirmationPopup] =
    useState(false);

  const handleDelete = (e) => {
    history.push(
      `/quote/${quoteid}`,
      `${quoteCode}@@${quoteid}@@Change@@/quote`,
    );
    setApprovedConfirmationPopup(false);
  };

  const [openLink, setOpenLink] = useState(false);
  const [selectedQuoteid, setSelectedQuoteid] = useState("");

  const [emailFromQuotesMailPopup, setEmailFromQuotesMailPopup] = useState("");
  const [approveQuotesEmailPopup, setApproveQuotesEmailPopup] = useState(false);

  const handleSendEmailQuotes = (e) => {
    dispatch(sendApprovedQuotesEmail(quoteid, emailFromQuotesMailPopup));
    setApproveQuotesEmailPopup(false);
  };

  const [openApprovedPopup, setOpenApprovedPopup] = useState(false);
  const [taskPerLine, setTaskPerLine] = useState(true);

  return (
    <>
      {isDownloadingQuote && (
        <div className="quote-download-loader" role="status" aria-live="polite">
          <Loader />
          <p>Preparing PDF download...</p>
        </div>
      )}

      {approveQuotesEmailPopup && (
        <QuotesApprovedMailPopup
          animation={true}
          handleDelete={handleSendEmailQuotes}
          show={approveQuotesEmailPopup}
          onHide={() => setApproveQuotesEmailPopup(false)}
          setQuotesEmail={setEmailFromQuotesMailPopup}
        />
      )}

      <QuotesApprovedPopup
        open={openApprovedPopup}
        onCancel={() => setOpenApprovedPopup(false)}
        onOk={() => {
          dispatch(ApproveQuotes(quoteid, token, taskPerLine));

          handleGeneralNotification(
            {
              notificationType: "CUSTOM",
              // text: "Quote quoteid is approved.",
              text: `Quote ${quoteCode} is approved.`,
            },
            false,
          );

          setOpenApprovedPopup(false);
        }}
        onTaskTypeChange={(value) => setTaskPerLine(value)}
        onTaskTypeChange2={(value) => {
          dispatch(ApproveQuotes(quoteid, token, value));
        }}
      />

      {openLink && selectedQuoteid === quoteid && (
        <div
          className="ps-3 py-2 ms-5 LinkBox parent"
          ref={openLinkBoxRef}
          style={{ width: "15%", position: "absolute" }}
        >
          <div
            className="d-flex align-items-star gap-2"
            onClick={(e) => {
              // navigator.clipboard.writeText(item.link);
              navigator.clipboard.writeText(link);
              // alert("Copy to clipboard");
              setOpenLink(false);

              handleGeneralNotification({
                notificationType: "CUSTOM",
                text: `Link copied to the clipboard.`,
              });
            }}
          >
            <img src={clipboard} alt="" width={15} />
            <p className="mb-0">
              {/* Copy link */}
              {t("Copy Link")}
            </p>
          </div>

          <div
            className="d-flex align-items-start gap-2 pt-3"
            onClick={() => {
              setApproveQuotesEmailPopup(true);
              setOpenLink(false);
            }}
          >
            <img src={send} alt="" width={15} />
            <p className="mb-0">
              {/* Send to client’s email */}
              {t("Send to client's email")}
            </p>
          </div>
        </div>
      )}

      <section
        className={`quoteListSection ${
          companyId == "28830f30-b321-4662-a576-f23451677741" ? "hide-link" : ""
        }`}
        style={{
          marginTop: "16px",
          position: "relative",
        }}
        key={index}
      >
        <p
          className="quoteListText quoteLink quote-list-head-mobile"
          style={{
            opacity:
              status === "Deactivated" || status === "Lost" ? "0.6" : "1",
            cursor: "pointer",
          }}
        >
          {packageId === process.env.REACT_APP_IS_PLUS ||
          packageId === process.env.REACT_APP_IS_PREMIUM ? (
            <QuoteLinkContextMenu
              quoteid={quoteid}
              quoteLink={link}
              key={quoteid}
            >
              <img
                src={Link}
                alt=""
                onClick={(e) => {
                  // if (e.button === 0) {
                  //   e.preventDefault();
                  //   e.stopPropagation();
                  //   return;
                  // }
                  e.stopPropagation(); //like => e.preventDefault.
                  setSelectedQuoteid(quoteid);
                  // setOpenLink(!openLink);

                  navigator.clipboard.writeText(link);
                  window.open(link, "_blank");
                }}
              />
              {/* <a href={link} target="_blank">
                {link}
              </a> */}
            </QuoteLinkContextMenu>
          ) : (
            ""
          )}
        </p>

        <p
          className="quoteListText color-bold"
          style={{
            opacity:
              status === "Deactivated" || status === "Lost" ? "0.6" : "1",
            cursor: "pointer",
            color: "#323232",
            fontWeight: "700",
          }}
          onClick={() => {
            {
              roleAccess !== ROLES.VIEWER &&
                history.push(
                  `/quote/${quoteid}`,
                  `${quoteCode}@@${quoteid}@@Change@@/quote`,
                );
            }
            window.sessionStorage.setItem("quoteLink", link);
          }}

          // onClick={() => {
          //   if (roleAccess !== ROLES.VIEWER) {
          //     if (status === "Approved") {
          //       setApprovedConfirmationPopup(true);
          //     } else {
          //       history.push("/quote-calculation", `${quoteCode}@@${quoteid}@@Change@@/quote`);
          //     }
          //   }
          // }}
        >
          {quoteCode}
        </p>

        <p
          className="quoteListText"
          style={{
            opacity:
              status === "Deactivated" || status === "Lost" ? "0.6" : "1",
            cursor: "pointer",
          }}
          onClick={() => {
            {
              roleAccess !== ROLES.VIEWER &&
                history.push(
                  `/quote/${quoteid}`,
                  `${quoteCode}@@${quoteid}@@Change@@/quote`,
                );
            }
            window.sessionStorage.setItem("quoteLink", link);
          }}
        >
          {/* {client?.clientname} */}
          {client?.clientname.length > 20
            ? client?.clientname.slice(0, 20) + "..."
            : client?.clientname}
        </p>

        <p
          className="quoteListText quote-list-head-mobile"
          style={{
            opacity:
              status === "Deactivated" || status === "Lost" ? "0.6" : "1",
            cursor: "pointer",
          }}
          onClick={() => {
            {
              roleAccess !== ROLES.VIEWER &&
                history.push(
                  `/quote/${quoteid}`,
                  `${quoteCode}@@${quoteid}@@Change@@/quote`,
                );
            }
            window.sessionStorage.setItem("quoteLink", link);
          }}
        >
          {projectCode}
        </p>
        <p
          className="quoteListText quote-list-head-mobile"
          style={{
            cursor: "pointer",
            opacity:
              status === "Deactivated" || status === "Lost" ? "0.6" : "1",
          }}
          onClick={() => {
            {
              roleAccess !== ROLES.VIEWER &&
                history.push(
                  `/quote/${quoteid}`,
                  `${quoteCode}@@${quoteid}@@Change@@/quote`,
                );
            }
            window.sessionStorage.setItem("quoteLink", link);
          }}
        >
          {/* {projectname} */}
          {projectname.length > 25
            ? projectname.slice(0, 25) + "..."
            : projectname}
        </p>

        {/* <p className="quoteListText quote-list-head-mobile">{quote?.total}</p> */}
        <p
          className="quoteListText quote-list-head-mobile color-bold"
          style={{ color: "#323232", fontWeight: "700" }}
        >
          {europeanFormatWithSymbol(total)}
        </p>

        <p
          className="quoteListstatus"
          style={{
            fontWeight: status === "Approved" ? "700" : "400",
            color: status === "Approved" ? "#00246A" : "#2B1710",
            opacity:
              status === "Deactivated" || status === "Lost" ? "0.6" : "1",
            cursor: "pointer",
          }}
          onClick={() => {
            {
              roleAccess !== ROLES.VIEWER &&
                history.push(
                  `/quote/${quoteid}`,
                  `${quoteCode}@@${quoteid}@@Change@@/quote`,
                );
            }
            window.sessionStorage.setItem("quoteLink", link);
          }}
        >
          {status}
        </p>

        {/* <p className="quoteListText quote-list-head-mobile d-flex gap-3">
          {quote.isPO !== 0 && (
            <img src={shoppingCartLight} alt="" />
          )}

          {quote.isinvoice !== 0 && (
            <img src={InvoiceLight} alt="" />
          )}
        </p> */}

        <img
          src={Kebab}
          alt="menu icon"
          className="quote-menu-icon"
          style={{
            transitionDuration: "300ms",
            transform: menuActiveList.includes(index) && "rotate(-90deg)",
            opacity:
              status === "Deactivated" || status === "Lost" ? "0.6" : "1",
          }}
          onClick={(e) => {
            localStorage.setItem("projectForPrint", projectname);
            localStorage.setItem("QuoteNoForPrint", quoteCode);
            localStorage.setItem(
              "clientNameForPrint",
              client?.clientname ?? "",
            );
            if (index >= quoteList?.length - 1) {
              setIsTop(true);
              setTop(-900);
            } else if (index >= quoteList?.length - 2) {
              setIsTop(true);
              setTop(-700);
            } else if (index >= quoteList?.length - 3) {
              setIsTop(true);
              setTop(-500);
            } else if (
              index >= quoteList?.length - 4 ||
              index >= quoteList?.length - 5
            ) {
              setIsTop(true);
              setTop(-400);
            } else {
              setIsTop(false);
            }
            // if (menuActive === true) return setMenuActive(false);
            // setMenuActive(true);

            e.stopPropagation(); //like => e.preventDefault.

            const indexExists = menuActiveList.includes(index);
            if (indexExists) {
              setMenuActiveList(
                menuActiveList.filter((item) => item !== index),
              );
            } else {
              setMenuActiveList([index]);
            }
          }}
        />
        <section
          ref={kebabRef}
          onClick={(e) => {
            e.stopPropagation(); //like => e.preventDefault.
          }}
          className="quote-menu quote-menu-2"
          style={{
            transform: menuActiveList.includes(index) ? "scale(1)" : "scale(0)",
            transitionDuration: "300ms",
            top: isTop && `${top}%`,
          }}
        >
          <div className="menu-icon-cont">
            <img
              src={Kebab}
              alt="menu icon"
              className="quote-menu-icon inside-menu"
              style={{
                transform: "rotate(-90deg)",
                opacity:
                  status === "Deactivated" || status === "Lost" ? "0.6" : "1",
              }}
              onClick={() => {
                // if (menuActive === true) return setMenuActive(false);
                // setMenuActive(true);
                setMenuActiveList([]);
              }}
            />
          </div>
          <div className="quote-menu-list fc">
            {ROLES.USER !== roleAccess &&
              ROLES.VIEWER !== roleAccess &&
              status !== "Approved" &&
              status !== "Deactivated" && (
                <section
                  className="fr menu-single-item"
                  style={{
                    gap: "10px",
                    opacity:
                      status === "Deactivated" || status === "Lost"
                        ? "0.6"
                        : "1",
                    pointerEvents:
                      status === "Deactivated" || status === "Lost"
                        ? "none"
                        : "auto",
                    fontSize: "clamp(14px, 1.025vw, 1.025vw)",
                  }}
                  onClick={() => {
                    // dispatch(ApproveQuotes(quoteid, token));
                    setOpenApprovedPopup(true);
                    // setMenuActive(false);
                    setMenuActiveList([]);

                    // handleGeneralNotification(
                    //   {
                    //     notificationType: "CUSTOM",
                    //     // text: "Quote quoteid is approved.",
                    //     text: `Quote ${quoteCode} is approved.`,
                    //   },
                    //   false,
                    // );
                  }}
                >
                  <img src={invoice} alt="Menu Icons" />
                  <p>
                    {/* Approve */}
                    {t("Approve")}
                  </p>
                </section>
              )}

            {ROLES.USER !== roleAccess &&
              ROLES.VIEWER !== roleAccess &&
              status === "Approved" && (
                <section
                  className="fr menu-single-item"
                  style={{
                    gap: "10px",
                    opacity:
                      status === "Deactivated" || status === "Lost"
                        ? "0.6"
                        : "1",
                    pointerEvents:
                      status === "Deactivated" || status === "Lost"
                        ? "none"
                        : "auto",
                    fontSize: "clamp(14px, 1.025vw, 1.025vw)",
                  }}
                  onClick={() => {
                    history.push({
                      pathname: "/NewInvoice",
                      state: {
                        from: "Quote_Screen",
                        historyQuoteid: quote.quoteid,
                        historyQuoteCode: quote.quotecode,
                        historyProjectid: quote.projectid,
                        historyProjectName: quote.projectname,
                        historyClientid: client?.clientid,
                        historyClientName: client.clientname,
                      },
                    });
                  }}
                >
                  <img src={invoice} alt="Menu Icons" />
                  <p>
                    {/* Make Invoice */}
                    {t("Make Invoice")}
                  </p>
                </section>
              )}

            {ROLES.USER !== roleAccess && ROLES.VIEWER !== roleAccess && (
              <section
                className="fr menu-single-item"
                style={{
                  gap: "10px",
                  opacity:
                    status === "Deactivated" || status === "Lost" ? "0.6" : "1",
                  pointerEvents:
                    status === "Deactivated" || status === "Lost"
                      ? "none"
                      : "auto",
                  fontSize: "clamp(14px, 1.025vw, 1.025vw)",
                }}
                onClick={() => {
                  if (roleAccess === ROLES.VIEWER)
                    return handleGeneralNotification({
                      notificationType: "CUSTOM",
                      text: `You don't have permission to duplicate quote.`,
                    });
                  dispatch(CreateDuplicateQuotes(quoteid, newQuoteCode));
                  // setMenuActive(false);
                  setMenuActiveList([]);
                }}
              >
                <img src={duplicate} alt="Menu Icons" />
                <p>
                  {/* Duplicate */}
                  {t("Duplicate")}
                </p>
              </section>
            )}

            {ROLES.VIEWER !== roleAccess && status === "Approved" && (
              <section
                className="fr menu-single-item"
                onClick={() => {
                  history.push({
                    pathname: `/quote/${quoteCode}/purshase-order`,
                    state: {
                      projectname: projectname,
                      suppliername: client.clientname,
                      supplierid: client.clientid,
                      quoteId: quoteid,
                      quoteCode: quoteCode,
                    },
                  });
                }}
                style={{
                  gap: "10px",
                  opacity:
                    status === "Deactivated" || status === "Lost" ? "0.6" : "1",
                  fontSize: "clamp(14px, 1.025vw, 1.025vw)",
                }}
              >
                <img src={shoppingCart} alt="Menu Icons" />
                <p>
                  {/* Purchase Order */}
                  {t("Purchasing Order")}
                </p>
              </section>
            )}

            <section
              className="fr menu-single-item"
              style={{
                gap: "10px",
                opacity:
                  status === "Deactivated" || status === "Lost" ? "0.6" : "1",
                pointerEvents:
                  status === "Deactivated" ||
                  status === "Lost" ||
                  isDownloadingQuote
                    ? "none"
                    : "auto",
                fontSize: "clamp(14px, 1.025vw, 1.025vw)",
              }}
              onClick={() => {
                downloadDefaultGrapesQuotePdf();
                setMenuActiveList([]);
              }}
            >
              <img src={pdf} alt="Menu Icons" />
              <p>
                {/* Download */}
                {t("Download")}
              </p>
            </section>

            {(ROLES.MANAGER === roleAccess || ROLES.OWNER === roleAccess) &&
              (status === "Approved" || status === "Deactivated") && (
                <section
                  className="fr menu-single-item"
                  style={{
                    gap: "10px",
                    fontSize: "clamp(14px, 1.025vw, 1.025vw)",
                    // opacity: status === "Deactivated" ? "0.6" : "1",
                  }}
                  // onClick={deactivateFunction}
                  onClick={() => {
                    deactivateFunction();
                    setMenuActiveList([]);
                  }}
                >
                  <img src={delete1} alt="Menu Icons" />
                  {/* <p>{status !== "Approved" ? "Activate" : "Deactivate"}</p> */}
                  <p>
                    {status !== "Approved" ? t("Activate") : t("Deactivate")}
                  </p>
                </section>
              )}
          </div>
        </section>
      </section>

      {/* print PDF modal data pass */}
      {/* <PrintModal
        printPopupShow={printPopupShow}
        setPrintPopupShow={setPrintPopupShow}
        downloadQuotePdfFunction={downloadQuotePdfFunction}
        link={link}
        quoteid={quoteid}
      /> */}
    </>
  );
};

const PrintModal = ({
  printPopupShow,
  setPrintPopupShow,
  downloadQuotePdfFunction,
  link,
  quoteid,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const availableTemplatesRes = useSelector(
    (state) => state.user.availableTemplates,
  );

  const quoteGenratePDFResponse = useSelector(
    (state) => state.user.quoteGenratePDFResponse,
  );

  const [templateOptionShow, setTemplateOptionShow] = useState(false);
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [availableTemplatesData, setAvailableTemplatesData] = useState([]);

  const [templateSearch, setTemplateSearch] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [templateid, setTemplateid] = useState("");
  const [templateTypeid, setTemplateTypeid] = useState("");
  const [printingOption, setPrintingOption] = useState("onlyPDF");

  const [quoteTemplatesPDFData, setQuoteTemplatesPDFData] = useState([]);

  useEffect(() => {
    if (printingOption === "Print_Using_Template") {
      dispatch(availableTemplates());
    }
  }, [printingOption]);

  useEffect(() => {
    if (availableTemplatesRes.status === true) {
      setAvailableTemplatesData(availableTemplatesRes?.data?.quotes);
    }
  }, [availableTemplatesRes]);

  useEffect(() => {
    if (quoteGenratePDFResponse.status === true) {
      setQuoteTemplatesPDFData(quoteGenratePDFResponse?.data);
    }
  }, [quoteGenratePDFResponse]);

  const handlePDFPrint = () => {
    if (printingOption === "onlyPDF") {
      downloadQuotePdfFunction();
      setPrintPopupShow(false);
      setPrintingOption("");
    } else if (printingOption === "Create_Online_version") {
      const win = window.open(link, "_blank");
      win.focus();
      setPrintPopupShow(false);
      setPrintingOption("");
    } else if (printingOption === "Print_Using_Template") {
      // dispatch(QuotesGeneratePDF(quoteid, templateid));
      dispatch(QuotesGeneratePDF(quoteid, templateid));
      // history.push(`/quote/${quoteid}/pdf`);
      setPrintPopupShow(false);
      setPrintingOption("");
    }
  };

  return (
    printPopupShow && (
      <div
        className="w-50"
        style={{
          width: "50%",
          border: "1px solid grey",
          borderRadius: "8px",
          position: "absolute",
          top: "100px",
          left: "200px",
          background: "#fff",
          zIndex: 2,
        }}
      >
        <div className="printOptions">
          <p className="mb-0">Print Options</p>
          <img
            className="pointer"
            src={close}
            alt=""
            onClick={() => {
              setPrintPopupShow(false);
              setPrintingOption("");
            }}
          />
        </div>

        <div
          style={{
            borderRadius: "0px 0px 8px 8px",
            padding: "15px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            className="d-flex gap-3 align-items-center pointer"
            onClick={() => {
              // downloadQuotePdfFunction();
              setPrintingOption("onlyPDF");
              // setPrintPopupShow(false);
              setTemplateOptionShow(false);
            }}
          >
            <p
              style={{
                borderRadius: "50%",
                border: "1px solid grey",
                padding: "7px",
                width: "7px",
                height: "7px",
                background: printingOption === "onlyPDF" ? "#00246A" : "white",
              }}
            ></p>
            <p>Create PDF</p>
          </div>

          <div
            className="d-flex gap-3 align-items-center pointer"
            onClick={() => {
              setPrintingOption("Create_Online_version");
              setTemplateOptionShow(false);
            }}
          >
            <p
              style={{
                borderRadius: "50%",
                border: "1px solid grey",
                padding: "7px",
                width: "7px",
                height: "7px",
                background:
                  printingOption === "Create_Online_version"
                    ? "#00246A"
                    : "white",
              }}
            ></p>
            <p>Create Online version</p>
          </div>

          <div
            className="d-flex gap-3 align-items-center pointer"
            onClick={() => {
              setPrintingOption("Print_Using_Template");
              setTemplateOptionShow(true);
              setArrowOptionsRotate(true);
            }}
          >
            <p
              style={{
                borderRadius: "50%",
                border: "1px solid grey",
                padding: "7px",
                width: "7px",
                height: "7px",
                background:
                  printingOption === "Print_Using_Template"
                    ? "#00246A"
                    : "white",
              }}
            ></p>
            <p>Print using template</p>
          </div>

          {/* template options start 👇*/}
          <projectSection>
            <div
              className="asc_Search_Box d-flex w-100"
              // ref={Project_Popup_Ref}
              style={{
                pointerEvents:
                  printingOption !== "Print_Using_Template" && "none",
              }}
            >
              {/* <input
                  type="text"
                  className="asc_Client_Input_For_Long ps-3"
                  placeholder="Select Client"
                  value={searchClientName}
                  onChange={(e) => {
                    setSearchClientName(e.target.value);
                    setClientShowOptions(true);
                  }}
                  onFocus={() => {
                    setClientShowOptions(true);
                    setArrowOptionsRotate(true);
                  }}
                /> */}
              <p
                className="asc_Client_Input_For_Long ps-3"
                onClick={() => {
                  setTemplateOptionShow(!templateOptionShow);
                  setArrowOptionsRotate(!arrowOptionsRotate);
                }}
              >
                {templateName ? templateName : "Select a template"}
              </p>

              {templateName ? (
                <img
                  src={Xicon}
                  className="xicon pointer mt-2"
                  alt=""
                  onClick={() => {
                    setTemplateSearch("");
                    setTemplateName("");
                    setTemplateTypeid("");
                    setTemplateTypeid("");

                    // setTypeInScreen("asc");
                    setArrowOptionsRotate(false);
                  }}
                />
              ) : (
                <img
                  src={DownArrowOption}
                  className={
                    arrowOptionsRotate
                      ? "upArrow mt-1 pointer"
                      : "downArrow mt-1 pointer"
                  }
                  alt=""
                  onClick={() => {
                    setTemplateOptionShow(!templateOptionShow);
                    setArrowOptionsRotate(!arrowOptionsRotate);
                  }}
                />
              )}

              {templateOptionShow && (
                <div
                  className="asc_Custom_Select_Outer"
                  style={{
                    borderTop: "none",
                  }}
                >
                  <section className="asc_Search_Icon_Search mx-2">
                    <img
                      src={searchicon}
                      className="asc_searchicon"
                      alt="Search Icon"
                    />
                    <input
                      id="asc_input"
                      className="asc_Search_Input"
                      placeholder="Search..."
                      value={templateSearch}
                      onChange={(e) => setTemplateSearch(e.target.value)}
                    />
                  </section>

                  <section
                    className="asc_Search_List pt-0 p-3"
                    id="ascSelectBox"
                  >
                    {availableTemplatesData
                      .filter(
                        (item) =>
                          item.templateName
                            ?.toLowerCase()
                            .includes(templateSearch.toLowerCase()) ||
                          item.projectcode
                            ?.toLowerCase()
                            .includes(templateSearch.toLowerCase()),
                      )
                      .map((item, index) => {
                        return (
                          <div
                            key={index}
                            className=""
                            onClick={() => {
                              setTemplateName(item.templateName);
                              setTemplateid(item.templateId);
                              setTemplateTypeid(item.templateTypeId);
                              setTemplateOptionShow(false);
                              // setChangeComp("asc");
                            }}
                          >
                            <p
                            // className={
                            //   projectid === item.projectid
                            //     ? "asc_Selected_Item ps-3"
                            //     : "ps-3"
                            // }
                            >
                              {/* {item.templateName} */}
                              {item.templateName.length > 25
                                ? item.templateName.slice(0, 25) + "..."
                                : item.templateName}
                            </p>
                          </div>
                        );
                      })}
                    {/* Display a message when no projects are found */}
                    {availableTemplatesData.length > 0 &&
                      availableTemplatesData.filter((item) =>
                        item.templateName
                          ?.toLowerCase()
                          .includes(templateSearch.toLowerCase()),
                      ).length === 0 && <span>No template found!</span>}

                    {/* Display a message when no data to display */}
                    {availableTemplatesData.length === 0 && (
                      <span className="noDataDisplay">No data to display!</span>
                    )}
                  </section>
                </div>
              )}
            </div>
          </projectSection>
          {/* template options end 👆*/}

          <div
            className="d-flex add-buttons mt-3"
            style={{ borderRadius: "12px", marginLeft: "35%" }}
            onClick={handlePDFPrint}
          >
            <p className="fw-bold mb-0">Print</p>
          </div>
        </div>
      </div>
    )
  );
};

export default Quote;
